<template>
  <div class="mem-plan">
    <Button style="margin-right:20px;" type="primary" :to="{name:'PlanEdit'}">添加会员计划</Button>
    <div class="content">
      <Grid
        ref="grid"
        :columns="column"
        data-url="/api/vipGrade"
        :rowsFormatter="rowsFormatter"
        selectType="none"
      >
        <template slot-scope="{ row }" slot="action">
          <Button type="text" size="small" :to="{name:'PlanEdit', query:{id: row.vip_grade_id}}">编辑</Button>-
          <Button type="text" size="small" @click="close(row)">{{row.status == 1 ? '禁用' : '启用'}}</Button>-
          <Button type="text" size="small" :to="{name:'OrderMember', query:{name: row.name}}">查看订单</Button>
        </template>
      </Grid>
    </div>
  </div>
</template>
<script>
export default {
  name: "MemberPlan",
  data() {
    return {
      column: [
        {
          title: "会员计划名称",
          key: "name",
          align: "center",
          minWidth: 200
        },
        {
          title: "会员时效",
          key: "time",
          align: "center",
          minWidth: 150
        },
        {
          title: "会员价格",
          key: "price",
          align: "center",
          minWidth: 150
        },
        {
          title: "类型",
          key: "grade_type_name",
          align: "center",
          minWidth: 150
        },
        {
          title: "状态",
          key: "status_name",
          align: "center",
          minWidth: 100
        },
        {
          title: "排序",
          key: "sort",
          align: "center",
          minWidth: 100
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          minWidth: 200,
          fixed: "right"
        }
      ]
    };
  },
  methods: {
    // 格式化时间
    rowsFormatter(rows) {
      rows.forEach(i => {
        i.time = "";
        if (i.year) i.time += i.year + "年";
        if (i.month) i.time += i.month + "个月";
        if (i.day) i.time += i.day + "天";
        i.status_name = i.status == 0 ? "禁用" : "正常";
        i.grade_type_name = i.grade_type == 1 ? "购买" : "赠送";
        i.price = this.$pub.calcPrice(i.price);
      });
    },
    close(row) {
      if (row.status == 1) {
        this.$Modal.confirm({
          title: "提示",
          content:
            "禁用后前台将隐藏，不可购买本会员计划，已购买的用户不受影响，确认禁用么？",
          onOk: () => {
            this.$http.put(`/api/vipGrade/on/${row.vip_grade_id}`).then(() => {
              this.$Message.success("成功");
              this.$refs.grid.searchRefresh();
            });
          }
        });
      } else {
        this.$http.put(`/api/vipGrade/on/${row.vip_grade_id}`).then(() => {
          this.$Message.success("成功");
          this.$refs.grid.searchRefresh();
        });
      }
    },
    /**
     * 新增/编辑属性
     */
    save(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          if (this.modalId != "") {
            // 编辑
            this.$http
              .put(`/api/attribute/${this.modalId}`, this.formValidate)
              .then(() => {
                this.search(1);
                this.showModel = false;
              });
          } else {
            //新增
            this.$http.post("/api/attribute", this.formValidate).then(() => {
              this.search(1);
              this.showModel = false;
            });
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.mem-plan {
  padding: 10px;
}
</style>

